import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ListItemKind } from './scrolling-list-state.service';
import { ApiSearch } from 'src/app/api/services/api-utils.service';

@Injectable()
export class ListSearchStateService {
  private originalSearchObject: ApiSearch = {
    query: undefined,
    sortBy: '',
    reverse: false,
    includeSubcompanies: false,
    folderId: null,
    folderKind: undefined,
    count: 40,
  };
  private searchObject: ApiSearch = { ...this.originalSearchObject };

  private search$ = new Subject<ApiSearch>();

  init(search: ApiSearch) {
    this.searchObject = { ...search };
    this.originalSearchObject = { ...search };
  }

  doSearch = () => {
    this.search$.next({
      ...this.searchObject,
    });
  };

  searchChanged() {
    return this.search$.asObservable();
  }

  reset() {
    this.searchObject = { ...this.originalSearchObject };
    this.doSearch();
  }

  setQuery(query: string) {
    this.searchObject.query = query;
  }

  sortBy(sortBy: string, reverse = undefined) {
    if (this.searchObject.sortBy === sortBy) {
      this.searchObject.reverse = !this.searchObject.reverse;
    } else {
      this.searchObject.sortBy = sortBy;
      this.searchObject.reverse = !!reverse;
    }
    this.doSearch();
  }

  setReverse(reverse: boolean) {
    this.searchObject.reverse = reverse;
  }

  setIncludeSubcompanies(includeSubcompanies: boolean) {
    this.searchObject.includeSubcompanies = includeSubcompanies;
  }

  setFolderId(folderId: string) {
    this.searchObject.folderId = folderId;
  }

  setKind(kind: ListItemKind) {
    this.searchObject.folderKind = kind;
  }

  getSearchObject() {
    return this.searchObject;
  }
}
